import type { ReactNode } from 'react';
import { Text } from '@savvy-kit/foundations/text';
import { cn } from '@savvy-kit/lib/utils';
import { ChevronRight } from 'lucide-react';

type PlaidLinkDefaultButtonProps = {
  readonly icon: ReactNode;
  readonly title: string;
  readonly loading?: boolean;
  readonly subtitle?: string;
  readonly onClick: () => void;
  readonly disabled?: boolean;
};

export default function PlaidLinkDefaultButton({
  icon,
  title,
  loading,
  subtitle,
  onClick,
  disabled,
}: PlaidLinkDefaultButtonProps) {
  const dimmed = loading || disabled;
  return (
    <div
      className={cn(
        'flex w-full flex-1 py-4 pl-4 pr-2',
        dimmed && 'opacity-30',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-component-hover',
      )}
      onClick={disabled ? undefined : onClick}
    >
      <div className="flex items-center justify-start">
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            {icon}
            <Text variant="subtitle-lg">{title}</Text>
          </div>

          {subtitle && (
            <div className="self-start pt-2">
              <Text variant="body-sm" color="secondary">
                {subtitle}
              </Text>
            </div>
          )}
        </div>
        <div className="self-start pl-2">
          <ChevronRight size={35} />
        </div>
      </div>
    </div>
  );
}
